import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useRegenerateAPITokenMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['APITokenRegeneration'],
    mutationFn: async () => {
      const response = await axios.post('/api_token_regeneration');
      return response.data;
    },
    onSuccess: (responseData) => {
      queryClient.setQueryData(
        ['APIToken'],
        (_existingDomainAPIToken) => responseData,
      );
    },
  });
}
